import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { rootReducer } from './reducers'
import sagas from './sagas'

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['user', 'staticContent', 'locationApi'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const sagaMiddleware = createSagaMiddleware()

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: { ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] },
    })
      .concat(sagaMiddleware)
      .concat(),
})

sagaMiddleware.run(sagas)

const persistor = persistStore(store)

export { store, persistor }
